export interface PageableComponent {
  setFirst(first: number);
}
